import React, { useState } from 'react';
import { EditExpenseCategory } from '../../pages';
import { MimaToastUtil } from '../../components';
import BusinessCategoryController from '../../controllers/BusinessCategoryController';
import constant from '../../utils/constant';
import * as yup from 'yup';
import { ExpenseCategoryController } from '../../controllers';

const EditExpenseCategoryContainer = ({closeModal, data}) => {
    const [loading, setLoading] = useState(false);

    const validationSchema = () => {
        return (
            yup.object().shape({
                name: yup.string().required("Enter category name"),  
                description: yup.string().max(50, "Characters should not be more than 50"),              
            })
        )
    }   

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            name: values.name,    
            description: values.description,               
        }
        const { status, errorMessage } = await ExpenseCategoryController.editExpenseCategories(            
            payload,
            data._id
            );

        if (status === constant.Success) {
            ExpenseCategoryController.getExpenseCategories();           
            MimaToastUtil.success({ message: constant.Success })          
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }
    return (
        <EditExpenseCategory
        loading={loading}
        onSubmit={onSubmit}
        closeModal={closeModal}
        data={data}
        validationSchema={validationSchema}
        />
    )
}
export default EditExpenseCategoryContainer;